import React, { Component } from 'react'
import Img from 'gatsby-image'

import Swiper from 'react-id-swiper'
import { Waypoint } from 'react-waypoint'

import 'swiper/css/swiper.css'
import './gallery.scss'

export class Gallery extends Component {
  state = {}

  params = {
    loop: false,
    speed: 300,
    freeMode: true,
    freeModeMomentumBounce: false,
    slidesPerView: `auto`,
    spaceBetween: -1,
    grabCursor: true,
    getSwiper: s => {
      this.setState({ swiper: s })
    },
  }

  startGallery = () => {
    this.state.swiper.slideNext(30000)
  }

  resetGallery = () => {
    this.state.swiper.slideTo(0, 0, false)
  }

  render() {
    const { block } = this.props

    return (
      <Waypoint
        bottomOffset={-50}
        topOffset={-50}
        onEnter={this.startGallery}
        onLeave={this.resetGallery}
      >
        <section className="gallery">
          <Swiper {...this.params}>
            {block.entry.map((entry, i) => {
              // console.log(entry)
              return (
                <div key={`gallery-${block.id}-image-${i}`}>
                  <Img fluid={entry.image.childImageSharp.fluid} />
                  <footer>{entry.legend}</footer>
                </div>
              )
            })}
          </Swiper>
        </section>
      </Waypoint>
    )
  }
}

export default Gallery
